import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import HomePage from '../HomePage/HomePage';
import AboutPage from '../AboutPage/AboutPage';
import ContactPage from '../ContactPage/ContactPage';
import PortfolioPage from '../PortfolioPage/PortfolioPage';
import WebsiteDesignPage from '../WebsiteDesign/WebsiteDesignPage';
import LogoDesignPage from '../LogoDesign/LogoDesignPage';
import AnimationAndIllustration from '../AnimationAndIllustration/AnimationAndIllustration';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="about" element={<AboutPage />} />  
          <Route path="portfolio" element={<PortfolioPage />} />  
          <Route path="website-design" element={<WebsiteDesignPage />} />  
          <Route path="logo-design" element={<LogoDesignPage />} />  
          <Route path="animation-and-illustration" element={<AnimationAndIllustration />} />  
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
